module.exports = __webpack_public_path__ + "img/Flag_of_Saint_Kitts_and_Nevis.beff9393.svg";